import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {NotFoundComponent} from './pages/not-found/not-found.component';
import {CoreComponent} from './core.component';
import {RouterLinkActive, RouterOutlet} from '@angular/router';
import {JsdIconComponent} from '../ui/jsd-icon/jsd-icon.component';
import {CoreRoutingModule} from './core-routing.module';
import {HomeComponent} from './pages/home/home.component';
import {PrivacyPolicyComponent} from './pages/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';


@NgModule({
    declarations: [
        CoreComponent,
        NotFoundComponent,
        HomeComponent,
        PrivacyPolicyComponent,
        TermsOfUseComponent
    ],
    exports: [
        CoreComponent
    ],
    imports: [
        CoreRoutingModule,
        CommonModule,
        NgOptimizedImage,
        RouterOutlet,
        JsdIconComponent,
        RouterLinkActive,
    ]
})
export class CoreModule {
}
